import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Can } from '@morningtrain/react-auth'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import { Collection, WhenCollectionIsNotEmpty, WhenModelValue } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'

export default function UserSalesPerformanceDashboardWidget () {
  return (
    <Can permission='api.dashboard.user_sales_performance'>
      <Widget>
        <Translator namespace='dashboard.user_sales_performance'>
          <Collection resourceName='dashboard' operationName='user_sales_performance'>
            <SelectedDepartmentFilter />
            <WhenCollectionIsNotEmpty>
              <UI.Card>
                <UI.CardHeader>
                  <UI.SecondaryHeading>
                    <Translation name='title' />
                  </UI.SecondaryHeading>
                </UI.CardHeader>
                <Table>
                  <Columns.Column
                          name="employee_name"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="columns.employee.label"/>}>
                                    <Translation name="columns.name.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  >
                    <UI.WithIcon
                            placement="right"
                            icon={(
                                    <>
                                      <WhenModelValue name="position_move" condition={1}>
                                        <UI.Text color="green">
                                          <UI.Icons.Up className="w-2 h-2"/>
                                        </UI.Text>
                                      </WhenModelValue>
                                      <WhenModelValue name="position_move" condition={-1}>
                                        <UI.Text color="red">
                                          <UI.Icons.Down className="w-2 h-2"/>
                                        </UI.Text>
                                      </WhenModelValue>
                                    </>
                            )}
                    >
                      <UI.WithSubtitle weight="medium" subtitle={<Displays.Text name="department.name"/>}>
                        <Displays.Text name="employee_name"/>
                      </UI.WithSubtitle>
                    </UI.WithIcon>
                  </Columns.Column>
                  <Columns.Currency
                          name="avg_basket_size"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.overall"/>}>
                                    <Translation name="columns.avg_order.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                  <Columns.Currency
                          name="basket_size_restaurant"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.inhouse"/>}>
                                    <Translation name="columns.avg_order.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                  <Columns.Number
                          name="beverages_per_guest_restaurant"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.inhouse"/>}>
                                    <Translation name="columns.avg_order_drinks.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                  <Columns.Currency
                          name="basket_size_take_away"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.takeaway"/>}>
                                    <Translation name="columns.avg_order.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                  <Columns.Number
                          name="beverages_per_guest_takeaway"
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.takeaway"/>}>
                                    <Translation name="columns.avg_order_drinks.label"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                  <Columns.Number
                          name="guest_count"
                          decimals={0}
                          label={(
                                  <UI.DoubleTableHead title={<Translation name="generic.count"/>}>
                                    <Translation name="generic.guests"/>
                                  </UI.DoubleTableHead>
                          )}
                  />
                </Table>
              </UI.Card>
            </WhenCollectionIsNotEmpty>
          </Collection>
        </Translator>
      </Widget>
    </Can>
  )
}
